// removed by extract-text-webpack-plugin
module.exports = {"body__wrapper":"dh-stille-spesial-body__wrapper","body__paragraph-wrapper":"dh-stille-spesial-body__paragraph-wrapper","body__header-wrapper":"dh-stille-spesial-body__header-wrapper","body__h2":"dh-stille-spesial-body__h2","body__h3":"dh-stille-spesial-body__h3","body__paragraph":"dh-stille-spesial-body__paragraph","body__paragraph--centered":"dh-stille-spesial-body__paragraph--centered","body__paragraph--spaced":"dh-stille-spesial-body__paragraph--spaced","body__image":"dh-stille-spesial-body__image","fact__box":"dh-stille-spesial-fact__box"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Body/index.css
// module id = 10
// module chunks = 0